import { render, staticRenderFns } from "./BlockedContainer.vue?vue&type=template&id=7c453580&scoped=true&"
import script from "./BlockedContainer.vue?vue&type=script&lang=js&"
export * from "./BlockedContainer.vue?vue&type=script&lang=js&"
import style0 from "./BlockedContainer.vue?vue&type=style&index=0&id=7c453580&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c453580",
  null
  
)

export default component.exports